import Textfield from "../Input/Textfield";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import { DeliveryMethods } from "@/shared/utils/enum";
import { emailPattern } from "@/shared/utils/patterns";
import useValidatePhoneNumber from "@/shared/hooks/useValidatePhoneNumber";
import usePosSettingsHook from "@/shared/hooks/usePosSettingsHook";
import usePosOrderUser from "@/shared/atoms/usePosOrderUser";
import usePaymentHook from "@/shared/hooks/usePaymentHook";
import usePosOrderPayment from "@/shared/atoms/usePosOrderPaymentAtom";

const FormOrderUserDetails = () => {
  const { t } = useTranslation();
  const [deliverMethodId] = usePosOrderDeliveryMethod();
  const [orderUser] = usePosOrderUser();
  const { register, errors } = useFormContext();
  const validatePhoneNumber = useValidatePhoneNumber();
  const [paymentId] = usePosOrderPayment();
  const { isOnlinePayment } = usePaymentHook();
  const {
    settings: { accept_all_addresses },
  } = usePosSettingsHook();

  const isRequiredForDelivery =
    deliverMethodId === DeliveryMethods.DELIVERY && !accept_all_addresses;

  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <Textfield
          ref={register({})}
          defaultValue={orderUser?.name}
          label={t("posOrders.name")}
          name="order_user.name"
        />
        <Textfield
          ref={register({})}
          defaultValue={orderUser?.company_name}
          label={t("posOrders.company_name")}
          name="order_user.company_name"
        />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Textfield
          ref={register({
            required: {
              value: isRequiredForDelivery,
              message: t("fieldRequired"),
            },
            validate: (data) =>
              isRequiredForDelivery ? validatePhoneNumber(data) : true,
          })}
          isRequired={isRequiredForDelivery}
          defaultValue={orderUser?.telephone}
          error={errors.order_user?.telephone?.message}
          label={t("posOrders.telephone")}
          name="order_user.telephone"
        />
        <Textfield
          ref={register({
            required: {
              value: !accept_all_addresses && isOnlinePayment(paymentId),
              message: t("fieldRequired"),
            },
            pattern: {
              value: emailPattern,
              message: t("emailIsNotCorrect"),
            },
          })}
          isRequired={!accept_all_addresses && isOnlinePayment(paymentId)}
          defaultValue={orderUser?.email}
          error={errors.order_user?.email?.message}
          label={t("posOrders.email")}
          name="order_user.email"
        />
      </div>
    </>
  );
};

export default FormOrderUserDetails;
